<template>
  <div class="">
    <div class="print-style">

      <!-- --kiosk-printing   -->

      <div class="col d-print-none mb-3 mt-3">


        <div class="container">

          <i @click="printPage()" class="bi bi-printer h1 custom-pointer-print-icon"/>
          <i @click="printUserInfo()" class="h1 bi bi-card-text mx-4 custom-pointer-print-icon"/>
          <div class="d-print-none d-inline-block" v-if="sidebarData">
            <template v-if=" sidebarData.status && sidebarData.status.status_id == 0 &&  sidebarData.order_type == 3">

              <!-- Button trigger modal -->
              <button type="button" class="btn btn-primary d-inline-block" data-toggle="modal" data-target="#pay_modal">
                پرداخت
              </button>

              <!-- Modal -->
              <div class="modal fade" id="pay_modal" tabindex="-1" aria-labelledby="pay_modalLabel"
                   aria-hidden="true">
                <div class="modal-dialog">
                  <div class="modal-content">
                    <div class="modal-header">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body">
                      <form @submit.prevent="submit">

                        <m-gate-manager1 v-model="selectedGate" :requiredInputs="true"/>


                        <div class="row my-3 text-center">
                          <div class="w-100">
                            <button :disabled="payButtonStatus" type="submit" class="btn px-5 btn-primary">پرداخت
                            </button>
                          </div>
                        </div>


                      </form>
                    </div>


                  </div>
                </div>
              </div>


            </template>
          </div>
        </div>


      </div>

      <div class="text-center">
        <h3 class="base-font-size print-mode-2">{{ pageTitle }}</h3>
      </div>



      <meta-manager1 class="" :metas="sidebarData.meta"/>


      <user-info class="" :info="sidebarData"/>

      <order-items class="print-mode-2 p-0 m-0" :items="sidebarData.items"/>

      <summarize-order class="print-mode-2" :info="sidebarData"/>

      <div v-if="transactionInfo != null && Object.keys(transactionInfo).length  > 0">

        <TransactionInfo class="d-print-none" :item="transactionInfo"/>

        <m-a v-if="Object.keys(transactionInfo).length == 1"
             :href="{name:'verifyTransaction',params:{slug:sidebarData.transaction.slug}}">
          <button class="btn btn-primary rounded-pill d-print-none my-3"
                  v-t="'factor.transaction_link'"></button>
        </m-a>
      </div>


      <div class="">
        <order-location1 :order="sidebarData" />
      </div>


    </div>

    <div class="col-lg-12 print-mode-2 text-center signature">
      <span class="mx-1" v-t="'address.address'"></span>
      <span>{{ findAttributeOnSiteInfo('address')[0] }} -</span>
      <span v-for="(tel_phone,index) in findAttributeOnSiteInfo('tel_phone')" :key="index" v-if="index===0">
        {{ tel_phone }}
      </span>
    </div>

    <div class="col-lg-12 print-mode-2 text-center signature">
      <span class="text-center col-lg-12">ساخت و طراحی توسط

        <m-a class="text-center" href="https://mixitweb.com/">Mixitweb.com</m-a>

      </span>
    </div>
  </div>


</template>

<script>
import {mapGetters} from "vuex";
import {formatNumber, dateConverter} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import OrderItems from "../FactorGeneralInfo/OrderItem/OrderItems1";
import UserInfo from "../FactorGeneralInfo/UserInfo/UserInfo1";
import SummarizeOrder from "../FactorGeneralInfo/SummerizeOrder/SummarizeOrder1";
import TransactionInfo from "../FactorGeneralInfo/TransactionInfo/TransactionInfo1";
import MetaManager1 from "../FactorGeneralInfo/Meta/MetaManager1.vue";
import mA from '../../Tags/A'
import mGateManager1 from "../../Gate/GateManager/GateManager1.vue";
import OrderLocation1 from "../FactorGeneralInfo/Meta/OrderLocation1.vue";

export default {
  name: "FactorAutoPrint1",
  components: {OrderLocation1, OrderItems, UserInfo, SummarizeOrder, TransactionInfo, mA, mGateManager1, MetaManager1},
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderPaidItems",
      transactionInfo: "Transaction/getTransaction",
      sidebarData: "Transaction/getFactor",
      loading: "Loading/loadingStatus"
    }),
    pageTitle() {
      return (this.sidebarData.transaction != null || (this.sidebarData.loan_transaction != null && this.sidebarData.loan_transaction.length != 0)) ? this.$t('factor.factor') : this.$t('factor.pre_factor')
    }
  },
  data() {
    return {
      selectedGate: '',
      payButtonStatus: false
    }
  },
  methods: {
    printPage() {
      const printMode2 = document.querySelectorAll('.print-mode-2')

      printMode2.forEach(item => {
        item.classList.remove('d-print-none')
      })

      window.print();
    },
    printUserInfo() {
      const printMode2 = document.querySelectorAll('.print-mode-2')

      printMode2.forEach(item => {
        item.classList.add('d-print-none')
      })

      window.print();
    },
    formatNumber,
    dateConverter,
    async submit() {
      this.payButtonStatus = true
      let order = this.sidebarData.id
      let gate = this.selectedGate

      let createTransaction = await this.$store.dispatch('Transaction/createTransaction', {
        order,
        gate
      })


    },
    setFactorData(req) {
      req.then(async (res) => {
        const response = await res.data.data;
        await this.$store.commit("ShoppingCart/setSidebarBasketData", response);
        await this.$store.commit("Transaction/setFactor", response);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        if (response.transaction == undefined) {
          await this.$store.commit("Transaction/setTransaction", response.loan_transaction);
        } else {
          await this.$store.commit("Transaction/setTransaction", response.transaction);
        }
      })
    },
  },
  async mounted() {

    let orderId;
    let req;

    let pageName = this.$route.name;


    /*
    *
    *
    * NOTE
    *  MAKE ONE OF THE CONDITION BELOW `TRUE`
    *
    *
    *
    * */


    if (pageName == 'FactorWithSlug') {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.slug : 'r0z1v3g9o2'
      req = this.$store.dispatch('Transaction/showOrderDetail', orderId)
    }
    if (pageName == 'Factor') {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.orderId : 585
      req = this.$store.dispatch('Transaction/autoPrintShowTransactionDetail', orderId)
    }
    if (pageName == 'verifyTransaction') {
      const slug = process.env.NODE_ENV != 'development' ? this.$route.params.slug : '0r0k0p4d8a3x'
      req = this.$store.dispatch("Transaction/verifyTransactionWithoutState", slug)
    }

    this.setFactorData(req)


  },
  watch: {
    loading(newValue, oldValue) {
      if (oldValue == true) {
        // add time out to make some time for loadign hide in page.
        setTimeout(() => {
          if (this.$route.query.print === 'on') {
            this.printPage()
          }
        }, 1_000)
      }
    }
  }
};
</script>

<style>

.custom-pointer-print-icon {
  cursor: pointer;
}

@media print {
  .signature, .signature * {
    font-size: 30px;
  }

  .raychat_automessage_preview_container, .raychat_main_button {
    display: none !important;
  }

  .base-font-size {
    font-size: 50px;
  }

  .print-style {
    font-size: 50px;
    width: 100% !important;
    font-weight: 10;
    color: #000;
    height: auto;
    border-bottom: none !important;
    border-top: 2px solid #000 !important;
    border-left: 2px solid #000 !important;
    border-right: 2px solid #000 !important;
    margin: 10px auto 0 auto;
  }

  .print-style .card {
    border: none !important;
  }

  .print-style tr {
    color: #000;
    border-bottom: 2px solid #000 !important;
    border-top: 2px solid #000 !important;
    border-left: none !important;
    border-right: none !important;
  }

  .table tr, .table th, .table td {
    border-bottom: 2px solid #000 !important;
    border-top: none !important;
    border-left: none !important;
    border-right: none !important;
  }


  .list, .print-style table, .print-style thead, .print-style tbody, .signature * {
    color: #000;
  }


}

</style>